/**
 * tabs.js — Sidebar navigation config.
 */
import { Home, Briefcase, Wallet, TrendingUp, Building2, Shield, Target, Flag, Settings } from '../components/icons';

export const TABS = [
  { id: "overview", l: "Overview", ic: Home },
  { id: "career", l: "Career", ic: Briefcase },
  { id: "budget", l: "Budget", ic: Wallet },
  { id: "investments", l: "Investments", ic: TrendingUp },
  { id: "realestate", l: "Real Estate", ic: Building2 },
  { id: "pension", l: "Pension", ic: Shield },
  { id: "projections", l: "Projections", ic: Target },
  { id: "milestones", l: "Milestones", ic: Flag },
  { id: "settings", l: "Settings", ic: Settings },
];
